import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {BreadcrumbItem} from '../../models/breadcrumb/breadcrumb-item';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  @Input() items: BreadcrumbItem[];
  tenant: string;
  @Output() navigateItem = new EventEmitter();

  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
  }

  itemClick(item): void {
    this.navigateItem.emit(item);
  }
}
